import { CampagneCreatorForm } from "@repo/campagne";
import { PageContainer } from "@repo/ui";
import { useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import { useCurrentUser } from "../lib/useCurrentUser";

export function CampagneCreator() {
  const currentUser = useCurrentUser();
  // Le sélecteur de groupe ne sert qu'aux gestionnaires (groupId vide) : un
  // utilisateur de groupe reste toujours scopé au sien côté serveur, cf.
  // convex/campagnes.ts:creerCampagne.
  const estGestionnaire = !!currentUser && !currentUser.groupId;
  const groupes = useQuery(
    api.groups.listerGroupesOrg,
    estGestionnaire ? {} : "skip",
  );

  return (
    <PageContainer>
      <CampagneCreatorForm
        applicationsAutorisees={currentUser?.applicationsAutorisees}
        groupes={estGestionnaire ? groupes : undefined}
        retourHref="/campagnes"
        retourLabel="Retour aux campagnes"
        // La page de la campagne créée, pas la liste : `/?campagne=…` renvoyait
        // sur la racine (liste des campagnes de l'organisation), le paramètre
        // n'étant lu nulle part.
        getCampagneHref={(campagneId) => `/campagnes/${campagneId}`}
        libreServiceBaseUrl={process.env.BUN_PUBLIC_APP_CANDIDATE_PORTAIL_URL}
      />
    </PageContainer>
  );
}
